module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_IN.d6377957.txt";